var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropdown" },
    [
      _c(
        "h5",
        {
          staticClass: "dropdown-toggle",
          attrs: {
            id: "annualSummitDropdown",
            "data-toggle": "dropdown",
            "aria-expanded": "false",
          },
          on: {
            click: function ($event) {
              _vm.showDropdown = !_vm.showDropdown
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.status === "success" ? _vm.item.EventTitle : "Event Info"
              ) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      ["not-found", "error"].includes(_vm.status)
        ? _c("el-empty", { attrs: { "image-size": 100 } })
        : _c(
            "div",
            {
              staticClass:
                "event-box-shadow event-left-content-inner dropdown-menu",
              class: { show: _vm.showDropdown },
              attrs: { "aria-labelledby": "annualSummitDropdown" },
            },
            [
              _c("div", { staticClass: "event-card-head" }, [
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", { staticClass: "event-card-avatar" }, [
                    _c("div", { staticClass: "event-initial-bg" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-initial-text font-light" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/icons/date-icon.svg"),
                            alt: "User",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-card-title" }, [
                    _c(
                      "div",
                      { staticClass: "event-individual-price font-light" },
                      [_vm._v("Date")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-individual-title" }, [
                      _vm._v(_vm._s(_vm.eventBeginDate)),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c("div", { staticClass: "event-card-head my-0" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("div", { staticClass: "event-card-avatar" }, [
                        _c("div", { staticClass: "event-initial-bg" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "event-initial-text font-light" },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/clock-icon.svg"),
                                alt: "Clock",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "event-card-title" }, [
                        _c(
                          "div",
                          { staticClass: "event-individual-price font-light" },
                          [_vm._v(_vm._s(_vm.isTBA ? "Time" : "From"))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "event-individual-title" }, [
                          _vm._v(_vm._s(_vm.eventBeginTime)),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                !_vm.isTBA
                  ? _c("div", { staticClass: "col-6" }, [
                      _c("div", { staticClass: "event-card-head my-0" }, [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("div", { staticClass: "event-card-title" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "event-individual-price font-light",
                              },
                              [_vm._v("To")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "event-individual-title" },
                              [_vm._v(_vm._s(_vm.eventEndTime))]
                            ),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.item.EventRSVPDateTime
                ? _c("div", { staticClass: "event-card-head" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("div", { staticClass: "event-card-avatar" }, [
                        _c("div", { staticClass: "event-initial-bg" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "event-initial-text font-light" },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/date-icon.svg"),
                                alt: "Date",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "event-card-title" }, [
                        _c(
                          "div",
                          { staticClass: "event-individual-price font-light" },
                          [_vm._v("RSVP by")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "event-individual-title" }, [
                          _vm._v(_vm._s(_vm.eventRSVPDateTime)),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _vm.item.EventVenueAddress1
                    ? _c("div", { staticClass: "event-card-head" }, [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("div", { staticClass: "event-card-avatar" }, [
                            _c("div", { staticClass: "event-initial-bg" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "event-initial-text font-light" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/icons/map-pin-icon.svg"),
                                    alt: "Map",
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-card-title" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "event-individual-price font-light",
                              },
                              [_vm._v("Venue")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "event-individual-title" },
                              [_vm._v(_vm._s(_vm.item.EventVenueAddress1))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "event-individual-title" },
                              [_vm._v(_vm._s(_vm.item.EventVenueAddress2))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "event-individual-title" },
                              [_vm._v(_vm._s(_vm.item.EventVenueAddress3))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "event-individual-title" },
                              [
                                _vm._v(
                                  _vm._s(_vm.item.EventVenueSuburb) +
                                    ", " +
                                    _vm._s(_vm.item.EventVenueState) +
                                    " " +
                                    _vm._s(_vm.item.EventVenuePostcode)
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.item.EventVenueAddress1 && _vm.item.EventVenueName
                    ? _c("div", { staticClass: "event-card-head" }, [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("div", { staticClass: "event-card-avatar" }, [
                            _c("div", { staticClass: "event-initial-bg" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "event-initial-text font-light" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/icons/map-pin-icon.svg"),
                                    alt: "Map",
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-card-title" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "event-individual-price font-light",
                              },
                              [_vm._v("Venue")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "event-individual-title" },
                              [_vm._v(_vm._s(_vm.item.EventVenueName))]
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.item.EventDressCode
                ? _c("div", { staticClass: "event-card-head" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("div", { staticClass: "event-card-avatar" }, [
                        _c("div", { staticClass: "event-initial-bg" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "event-initial-text font-light" },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/dress-code-icon.svg"),
                                alt: "Dress Code",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "event-card-title" }, [
                        _c(
                          "div",
                          { staticClass: "event-individual-price font-light" },
                          [_vm._v("Dress code")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "event-individual-title" }, [
                          _vm._v(_vm._s(_vm.item.EventDressCode)),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.item.EventDoorsOpenDateTime
                ? _c(
                    "div",
                    { staticClass: "event-card-head event-card-head-last" },
                    [
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "event-card-avatar" }, [
                          _c("div", { staticClass: "event-initial-bg" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-initial-text font-light" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/icons/clock-icon.svg"),
                                  alt: "Clock",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "event-card-title" }, [
                          _c(
                            "div",
                            {
                              staticClass: "event-individual-price font-light",
                            },
                            [_vm._v("Doors open time")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-individual-title" }, [
                            _vm._v(_vm._s(_vm.eventDoorsOpenDateTime)),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }